/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];
const asArray = (value) => (Array.isArray(value) ? value : []);

const addOnsSlice = createSlice({
    name: 'addOns',
    initialState: initialState,
    reducers: {
        setAddOnsData: (state, action) => {
            return asArray(action.payload);
        },
        addAddOnsData: (state, action) => {
            return [...asArray(state), action.payload];
        },
        updateAddOnsData: (state, action) => {
            return asArray(state).map((item) => (item.id === action.payload.id ? action.payload : item));
        },
        deleteAddOnsData: (state, action) => {
            return asArray(state).filter((item) => item.id !== action.payload.id);
        },
        resetAddOnsData: () => {
            return initialState;
        },
    },
});

export const { setAddOnsData, addAddOnsData, updateAddOnsData, deleteAddOnsData, resetAddOnsData } =
    addOnsSlice.actions;
export default addOnsSlice.reducer;
